<div class="ds-info-banner">
  <!-- Custom icon if provided, otherwise default info icon -->
  <img
    *ngIf="iconSrc"
    [src]="iconSrc"
    alt=""
    class="ds-info-icon"
  />
  <svg
    *ngIf="!iconSrc"
    class="ds-info-icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#33A3B0"/>
  </svg>
  <p class="ds-info-text">
    <strong *ngIf="text" class="ds-info-text-bold">{{ text }}</strong>
    <br class="ds-info-text-break-mobile" aria-hidden="true" />
    <ng-container *ngIf="linkUrl && linkText">
      <!-- External link (https://...) -->
      <a
        *ngIf="linkUrl && (linkUrl.startsWith('http://') || linkUrl.startsWith('https://'))"
        [href]="linkUrl"
        rel="noopener noreferrer"
        class="ds-info-link"
      >
        {{ linkText }}
      </a>
      <!-- Internal router link (/) -->
      <a
        *ngIf="linkUrl && linkUrl.startsWith('/') && !linkUrl.startsWith('//') && !linkUrl.startsWith('http://') && !linkUrl.startsWith('https://')"
        [routerLink]="linkUrl"
        class="ds-info-link"
      >
        {{ linkText }}
      </a>
    </ng-container>
  </p>
</div>

